import { Icon } from 'antd';

export default class extends React.Component {
    constructor(props) { super(props); }
    render() {
        const iconStyle = { fontSize: '1.5em', marginRight: '8px' };
        return (
            <div className='ss-cmpts-reg-common-container'>
                <Icon type='warning' style={iconStyle} />
                <span className='ss-cmpts-reg-cand-text'>
                    {'Email address and username already exists'}
                </span>
                <div className='ss-cmpts-reg-error-subtitle-login-msg'>
                    {'Please login to access your account.'}
                </div>
            </div>
        );
    }
}